/**
 * Autoridad en E-commerce (Payments), decidida por el humano el 2026-10-05:
 * la da un gestor de servicio PAYMENTS cuyo PROPIO rol es 1 o 7. No se deriva del
 * rol global de banca (el `IsAdmin` del back justamente EXCLUYE a los gestores
 * PAYMENTS). Es el predicado ÚNICO: alta de comercio (feature 44) y lecturas LIVE
 * (feature 48) lo consumen a través de `UserRoleService`. TypeScript puro.
 */

/** Servicio del gestor que da acceso a E-commerce (payload de sesión, rama "Sidebar PAYMENTS"). */
export const SERVICIO_PAYMENTS = 'PAYMENTS';

/** Roles del gestor PAYMENTS con autoridad en E-commerce: alta de comercio (44) y lecturas LIVE (48). Humano, 2026-10-05. */
export const ROLES_AUTORIDAD_PAYMENTS: ReadonlySet<number> = new Set([1, 7]);

/** Forma mínima de un gestor de la sesión que este predicado necesita leer. */
export interface GestorDeSesionAlta {
  readonly service?: unknown;
  readonly role?: { readonly id?: unknown } | null;
  readonly is_active?: unknown;
}

function normalizarServicio(valor: unknown): string {
  return String(valor ?? '').trim().toUpperCase();
}

/**
 * `true` si y solo si algún gestor es de servicio PAYMENTS, no viene con
 * `is_active: false` y SU rol es 1 o 7. Un rol 1/2/7 en un gestor de otro servicio
 * (SPEI, CARDS, TPV, legacy sin servicio) NO cuenta. Un pase; corta en el primer acierto.
 */
export function tieneAutoridadPayments(
  gestores: readonly GestorDeSesionAlta[] | null | undefined,
): boolean {
  if (!Array.isArray(gestores)) return false;
  return gestores.some(
    (g) =>
      normalizarServicio(g?.service) === SERVICIO_PAYMENTS &&
      g?.is_active !== false &&
      ROLES_AUTORIDAD_PAYMENTS.has(Number(g?.role?.id)),
  );
}
